
export default function splitEmailString(emailString: string|null): string[] {
    return (emailString || "").split(/[,;\s/]+/).filter((email) => !!email);
}
